/* Progressive enhancement: without JavaScript the complete article remains readable. */
(function () {
  'use strict';
  function initialize(root) {
    root.querySelectorAll('[data-article-toc]').forEach(function (body) {
      if (body.dataset.articleTocReady) return;
      body.dataset.articleTocReady = 'true';
      var doc = body.ownerDocument;
      var counts = new Map();
      doc.querySelectorAll('[id]').forEach(function (node) {
        counts.set(node.id, (counts.get(node.id) || 0) + 1);
      });
      var legacyCounts = new Map(counts);
      var headings = Array.from(body.querySelectorAll('h2')).filter(function (heading) {
        return heading.textContent.trim() && !heading.closest('[hidden], [aria-hidden="true"]');
      });
      if (!headings.length) return;
      var nav = doc.createElement('nav');
      nav.className = 'article-editorial article-editorial--toc';
      nav.setAttribute('aria-label', body.dataset.tocLabel);
      var title = doc.createElement('div');
      title.className = 'article-editorial__heading';
      title.textContent = body.dataset.tocLabel;
      title.setAttribute('aria-hidden', 'true');
      var details = doc.createElement('details');
      details.className = 'article-editorial__toc-details';
      var summary = doc.createElement('summary');
      summary.className = 'article-editorial__toc-summary';
      summary.textContent = body.dataset.tocLabel;
      details.appendChild(summary);
      var media = doc.defaultView && doc.defaultView.matchMedia && doc.defaultView.matchMedia('(max-width: 767px)');
      function setViewport(event) { details.open = !event.matches; }
      setViewport(media || { matches: false });
      if (media && media.addEventListener) media.addEventListener('change', setViewport);
      else if (media && media.addListener) media.addListener(setViewport);
      var list = doc.createElement('ol');
      list.className = 'article-editorial__list';
      headings.forEach(function (heading, index) {
        var id = heading.id;
        if (!id || counts.get(id) !== 1 || /\s/.test(id)) {
          var legacyBase = 'article-' + body.dataset.articleToc + '-section-' + (index + 1);
          var legacyId = legacyBase;
          var legacySuffix = 1;
          while (legacyCounts.has(legacyId)) legacyId = legacyBase + '-' + legacySuffix++;
          legacyCounts.set(legacyId, 1);
          var base = heading.textContent.trim().normalize('NFKD').replace(/\p{M}/gu, '')
            .toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '').slice(0, 100).replace(/-+$/g, '');
          if (!base) base = 'section-' + (index + 1);
          id = base;
          var suffix = 2;
          while (counts.has(id)) id = base + '-' + suffix++;
          var anchor = doc.createElement('span');
          anchor.id = id;
          anchor.className = 'article-editorial__anchor';
          anchor.tabIndex = -1;
          heading.before(anchor);
          counts.set(id, 1);
          // Keep old preview links working when no other element owns the old ID.
          if (!counts.has(legacyId)) {
            var legacy = doc.createElement('span');
            legacy.id = legacyId;
            legacy.className = 'article-editorial__anchor';
            legacy.tabIndex = -1;
            heading.before(legacy);
            counts.set(legacyId, 1);
          }
        }
        var item = doc.createElement('li');
        var link = doc.createElement('a');
        link.setAttribute('href', '#' + encodeURIComponent(id));
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
      details.appendChild(list);
      nav.append(title, details);
      body.before(nav);
      // A fragment may have been navigated before these dynamic anchors existed.
      var hash = doc.defaultView && doc.defaultView.location && doc.defaultView.location.hash;
      if (hash) {
        var targetId;
        try { targetId = decodeURIComponent(hash.slice(1)); } catch (error) { targetId = hash.slice(1); }
        var target = doc.getElementById(targetId);
        if (target && target.classList.contains('article-editorial__anchor') && target.scrollIntoView) {
          if (doc.defaultView.requestAnimationFrame) doc.defaultView.requestAnimationFrame(function () { target.scrollIntoView(); });
          else target.scrollIntoView();
        }
      }
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = initialize;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
    else initialize(document);
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  }
}());
